import Loading from '@/shared/components/Carregando';
import Select from 'react-select';
import { AplicationService } from '@/modules/system/app/app.service';
import { CACHE_MOVIMENTOS } from '@/shared/constants/strings';
import { ConfiguracoesSistema } from '../enum/configuracoes-sistema.enum';
import { Form, useLocation, useParams } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import { LerRegistrosDoMovimento, processosToArray, processosToString } from '../movimentacao.service';
import { LerTipoMovimentacoes } from '@/modules/business/movimentacoes_tipos/movimentacaotipo.service';
import { Modal, Button } from 'react-bootstrap';
import { MovimentacaoRegistrosDto, ReadMovimentacaoTipoDto } from '@/api.types';
import { toast } from 'react-toastify';

interface parametros {
  ehnucleo: boolean;
  updateRegistros: (lista: MovimentacaoRegistrosDto[]) => void;
}

export default function TabelaRegistros({ updateRegistros, ehnucleo, }: parametros) {

  const applicationService = new AplicationService();

  const params = useParams();
  const id = params.id ? Number(params.id) : 0;
  const location = useLocation();

  const [registros, setRegistros] = useState<MovimentacaoRegistrosDto[]>([]);
  const [tipos, setTipos] = useState<ReadMovimentacaoTipoDto[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [showPropProcessos, setShowPropProcessos] = useState(false);
  const [somenteInicial, setSomenteInicial] = useState(true);

  const [uiTipoModal, setTipoModal] = useState<number | undefined>();
  const [uiQuantidadeModal, setUiQuantidadeModal] = useState<number | undefined>();
  const [numerosProcessos, setNumerosProcesso] = useState<number[]>([]);
  const [processoNumero, setProcessoNumero] = useState<number | string>('');
  const [tiposComProcessos, setTiposComProcessos] = useState<number[]>([]);

  const [cache, setCache] = useState<MovimentacaoRegistrosDto[]>();
  const [loaded, setLoaded] = useState<boolean>(false);

  // Carrega cache do navegador e tipos de movimentações.
  useEffect(() => {
    const cacheNavegador = localStorage.getItem(CACHE_MOVIMENTOS);
    if (cacheNavegador) {
      try {
        const cacheValido = JSON.parse(
          cacheNavegador,
        ) as MovimentacaoRegistrosDto[];
        setCache(cacheValido);
      } catch {
        localStorage.removeItem(CACHE_MOVIMENTOS);
        setCache(undefined);
      }
    }

    applicationService.readConfiguracoes().then((res) => {
      const configs = res.find(
        (a) => a.chave === ConfiguracoesSistema.TiposComProcesso,
      );
      if (configs) {
        const p = processosToArray(configs.valor);
        setTiposComProcessos(p);
      }
    });

    LerTipoMovimentacoes(0, 1000, ehnucleo).then((res) => {
      setTipos(res.objects);
      setLoaded(true);
    });
  }, []);

  // Carrega os registros do movimento.
  useEffect(() => {
    if (!loaded) return;

    if (id) {
      LerRegistrosDoMovimento(id).then((res) => {
        if (res) setRegistros(res.objects);
        else if (cache) {
          setRegistros(cache);
        }
      });
    } else {
      if (cache) {
        setRegistros(cache);
      }
    }
  }, [id, ehnucleo, loaded, cache, location.pathname]);

  const handleShow = (rowData: MovimentacaoRegistrosDto | null) => {
    if (rowData) {
      setSomenteInicial(rowData.tipo?.inicial);
      setTipoModal(rowData.tipo?.id);

      const p = processosToArray(rowData.processos);
      setNumerosProcesso(p);
      setUiQuantidadeModal(p.length > 0 ? p.length : rowData.quantidade);

      setShowPropProcessos(
        tiposComProcessos.findIndex((a) => a == rowData.tipo.id) >= 0,
      );
    } else {
      setTipoModal(tipos[0].id);
      setUiQuantidadeModal(1);
      setNumerosProcesso([]);
      setShowPropProcessos(
        tiposComProcessos.findIndex((a) => a == tipos[0].id) >= 0,
      );
    }
    setProcessoNumero('');
    setShowModal(true);
  };

  function salvarRegistro() {
    // Busca o tipo completo da lista de tipos
    const tipoCompleto = tipos.find((t) => t.id === uiTipoModal);
    if (!tipoCompleto) {
      toast.error('Tipo de movimentação não encontrado.');
      return;
    }

    const jaExiste = registros.findIndex(
      (item) => item.tipo?.id == uiTipoModal,
    );

    if (jaExiste >= 0) {
      registros[jaExiste].quantidade = uiQuantidadeModal!;
      registros[jaExiste].processos =
        processosToString(numerosProcessos);
      registros[jaExiste].tipo = tipoCompleto;
    } else {
      const objeto = {
        quantidade: uiQuantidadeModal!,
        tipo: tipoCompleto,
        processos: processosToString(numerosProcessos),
      };
      registros.push(objeto as MovimentacaoRegistrosDto);
    }
    updateRegistros(registros);
    setShowModal(false);

    localStorage.setItem(CACHE_MOVIMENTOS, JSON.stringify(registros));
  }

  function removerRegistro(idTipo: number | undefined) {
    const n = registros.filter((item) => item.tipo?.id !== idTipo);
    setRegistros(n);
    updateRegistros(n);
    localStorage.setItem(CACHE_MOVIMENTOS, JSON.stringify(n));
  }

  const handleCheckboxChange = () => {
    const novoValor = !somenteInicial;
    setSomenteInicial(novoValor);

    const tiposFiltrados = tipos.filter((a) => a.inicial === novoValor && a.nucleo === ehnucleo);

    if (tiposFiltrados.length > 0 && !tiposFiltrados.some((tipo) => tipo.id === uiTipoModal)) {
      setTipoModal(tiposFiltrados[0].id);
    }
  };

  // const handleChageTipo = (e: React.ChangeEvent<HTMLSelectElement>) => {
  // 	const t = e.target.value as unknown as number
  // 	setTipoModal(t)

  // 	const s = tiposComProcessos.findIndex(a => a == t) >= 0
  // 	setShowPropProcessos(s)
  // 	if (s) {
  // 		setUiQuantidadeModal(numerosProcessos.length);
  // 	} else {
  // 		setNumerosProcesso([])
  // 	}
  // }

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter' || !processoNumero) return;

    if (numerosProcessos.find((a) => a == processoNumero)) {
      toast.warning('Número já inserido.');
      return;
    }

    if (isNaN(Number(processoNumero))) {
      toast.warning('Valor não é um número.');
      return;
    }

    if (processoNumero.toString().length != 12) {
      toast.warning(
        `O número de processo deve ter 12 caracteres.${processoNumero.toString().length}`,
      );
      return;
    }

    numerosProcessos.push(Number(processoNumero));
    setNumerosProcesso(numerosProcessos.sort((a) => a));
    setProcessoNumero('');
    setUiQuantidadeModal(numerosProcessos.length);
  };

  const handleRemoverProcesso = (e: React.MouseEvent<HTMLSpanElement>) => {
    const processoNumero = e.currentTarget.textContent;
    if (!processoNumero) return;

    const listaFiltrada = numerosProcessos.filter(
      (a) => a !== Number(processoNumero),
    );
    setNumerosProcesso(listaFiltrada);
    setUiQuantidadeModal(listaFiltrada.length);
  };

  if (!loaded)
    return <Loading />;

  return (

    < Fragment >
      <div className="card">
        <div className="card-header">
          <h5 className="text-center">Registros</h5>
        </div>
        <div>
          <button type="button" className="btn btn-sm btn-outline-primary mt-3" onClick={() => handleShow(null)} >
            Adicionar Registro
          </button>
        </div>

        <div className="card-body row">
          <table className="table table-sm table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th className="text-center">Inicial</th>
                <th>Descrição do Movimento</th>
                <th className="text-center">Quantidade</th>
                <th className="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              {registros &&
                registros.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={item.tipo?.inicial}
                        readOnly={true}
                      ></input>
                    </td>
                    <td>{item.tipo?.descricao}</td>
                    <td className="text-center">{item.quantidade}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm me-2"
                        onClick={() => handleShow(item)}
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => removerRegistro(item.tipo?.id)}
                      >
                        Excluir
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Registros</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="uiQuantidade">Quantidade: </label>
              <input
                id="uiQuantidade"
                type="number"
                title="Total de Atendimentos"
                min={0}
                max={9999}
                disabled={showPropProcessos}
                className="form-control"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setUiQuantidadeModal(e.target.value as unknown as number)
                }
                value={uiQuantidadeModal}
              />
            </div>
            <div className="col-md-10 mb-2">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="uiTiposIniciais"
                  checked={somenteInicial}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="uiTiposIniciais">
                  Tipos Iniciais
                </label>
              </div>
              <div>
                <Select
                  id="uiTipoSelecionado"
                  className="basic-single"
                  classNamePrefix="select"
                  isSearchable={true}
                  options={tipos
                    .filter(
                      (a) =>
                        a.inicial === somenteInicial && a.nucleo === ehnucleo,
                    )
                    .map((item) => ({
                      value: item.id,
                      label: item.descricao,
                    }))}
                  value={{
                    value: uiTipoModal || 0,
                    label:
                      tipos.find((t) => t.id === uiTipoModal)?.descricao ||
                      'Selecione',
                  }}
                  onChange={(selectedOption) => {
                    const t = selectedOption?.value as number;
                    setTipoModal(t);

                    const s = tiposComProcessos.findIndex((a) => a == t) >= 0;
                    setShowPropProcessos(s);
                    if (s) {
                      setUiQuantidadeModal(numerosProcessos.length);
                    } else {
                      setNumerosProcesso([]);
                    }
                  }}
                />
              </div>
            </div>

            {(showPropProcessos || numerosProcessos.length > 0) && (
              <>
                <div className="col-md-4 mt-2">
                  <label htmlFor="anotacoes_registro" className="form-label">
                    Processo:{' '}
                  </label>
                  <input
                    id="anotacoes_registro"
                    type="number"
                    className="form-control"
                    min={0}
                    max={999999999999}
                    value={processoNumero ?? ''}
                    onChange={(e) =>
                      setProcessoNumero(
                        e.target.value ? Number(e.target.value) : '',
                      )
                    }
                    onKeyDown={handleOnKeyDown}
                  />
                </div>

                <div className="col-md-8 mt-5">
                  {(numerosProcessos ?? []).map((element, index) => (
                    <span
                      key={index}
                      className="badge rounded-pill bg-secondary ms-2"
                      onDoubleClick={handleRemoverProcesso}
                      title={`Dois cliques para remover o processo: ${element.toString()} `}
                    >
                      {element.toString()}
                    </span>
                  ))}
                </div>
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={salvarRegistro}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment >
  );
}
